export default __webpack_public_path__ + "static/media/basicaUm.1386e017.png";